import { Spinner } from 'react-bootstrap';
import { Typography } from 'Components/atoms';
import { InventoryGrid } from 'Components/organisms/InventoryGrid';
import { useEarlyAccess } from 'Hooks/useEarlyAccess';
import useTimeSpent from 'Hooks/useTimeSpent';

const COMPONENT_IDENTIFIER = 'Inventory Page';

/**
 * Inventory dashboard (APD-1755). Gated behind the experimental / Early Access
 * setting: the nav entry is hidden unless early access is enabled, and this
 * page-level guard covers direct-URL access to the same effect.
 */
const InventoryPage = () => {
    useTimeSpent(COMPONENT_IDENTIFIER);
    const { isEarlyAccessEnabled, isLoading } = useEarlyAccess();

    const renderBody = () => {
        if (isLoading) {
            return (
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                    <Spinner animation="border" />
                </div>
            );
        }
        if (!isEarlyAccessEnabled) {
            return (
                <div className="bg-text-black p-4 card">
                    <Typography variant="subtitle2" color="text-high-emphasis">
                        Inventory
                    </Typography>
                    <Typography variant="body3" color="text-medium-emphasis" className="mt-2">
                        This feature is available with experimental features enabled. Ask your administrator to turn on
                        Early Access in Settings.
                    </Typography>
                </div>
            );
        }
        return (
            <div className="inventory-page__body flex-grow-1">
                <InventoryGrid />
            </div>
        );
    };

    return (
        <div className="inventory-page pt-4 pb-4 w-100 h-100 d-flex flex-column gap-2">
            <h2 className="m-0 text-text-high-emphasis">Inventory</h2>
            {renderBody()}
        </div>
    );
};

export default InventoryPage;
